import { css, CTA, styled } from '@volkswagen-onehub/components-core';

export const NavMenuContainer = styled.div`
  width: 100%;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 8px;

  flex-grow: 1;
`;

export const NavSection = styled.div``;

export const NavHeader = styled.button<{ $open?: boolean; $level?: number }>`
  width: 100%;

  background: none;
  border: none;
  outline: none;
  text-align: left;

  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*transition: background 0.2s ease;*/

  border-radius: 8px;

  padding: 8px;
  padding-left: ${({ $level = 0 }) => 8 + $level * 8}px;

  ${({ $open }) =>
    $open &&
    css`
      font-weight: 700;
    `}
`;

export const Arrow = styled.div<{ $open?: boolean }>`
  opacity: 0.6;
  transform: rotate(${({ $open }) => ($open ? '-90deg' : '90deg')});
  transition: transform 0.2s ease;
  margin-left: 12px;
`;

export const NavList = styled.ul<{ $open?: boolean; $level?: number }>`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: ${({ $open }) => ($open ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
  padding-left: ${({ $level = 0 }) => ($level + 1) * 8}px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const NavLink = styled(CTA)<{ $level?: number }>`
  width: 100%;
  background: none;
  border: none;
  outline: none;
  text-align: left;
  justify-content: flex-start;

  border-radius: 8px;

  cursor: pointer;
  text-decoration: none;
  transition: color 0.15s;

  padding: 8px;
  padding-left: ${({ $level = 0 }) => 8 + $level * 8}px;
`;

export const StandaloneNavLink = styled.a`
  display: block;
  text-decoration: none;
  color: #333;
  padding: 10px 0px;
  font-size: 14px;
  transition: color 0.15s;

  &:hover {
    text-decoration: underline;
  }
`;
